export class SearchModel{
    search!:string;

    constructor(){
        this.search = "";
    }
}